// extracted by mini-css-extract-plugin
export var macStatementCompass = "index-module--mac-statement-compass--ac51d";